import { render, staticRenderFns } from "./SolutionPartner.vue?vue&type=template&id=2c30d1de&scoped=true&"
import script from "./SolutionPartner.vue?vue&type=script&lang=js&"
export * from "./SolutionPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c30d1de",
  null
  
)

export default component.exports